module.exports = __webpack_public_path__ + "img/warning.2e319ba3.svg";